import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from 'utility/helperFunctions'

// React Router v7 - PrivateRoute using element prop
export function PrivateRoute({ element }) {
  return isAuthenticated() ? element : <Navigate to="/login" replace />;
}

// React Router v7 - PublicRoute using element prop
export function PublicRoute({ element }) {
  return isAuthenticated() ? <Navigate to="/" replace /> : element;
}
